/* Native Shopify repeated-value OR; only equivalent rectangular labels. */
(() => {
  'use strict';
  const param = 'filter.v.option.ebat';
  const key = value => {
    const match = String(value).trim().toLowerCase().match(/^(\d+)\s*[x×]\s*(\d+)\s*(?:cm)?$/);
    return match ? `${match[1]}x${match[2]}` : null;
  };
  const label = k => k.replace('x', ' × ') + ' cm';
  class CottonEbatAliases extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const groups = new Map();
      for (const input of this.querySelectorAll(`input[type="checkbox"][name="${param}"]`)) {
        const k = key(input.value);
        if (k) { if (!groups.has(k)) groups.set(k, []); groups.get(k).push(input); }
      }
      for (const [k, inputs] of groups) {
        if (inputs.length < 2) continue;
        const master = inputs[0];
        const checked = inputs.some(input => input.checked);
        const disabled = inputs.every(input => input.disabled);
        for (const input of inputs) {
          input.checked = checked;
          input.disabled = disabled;
          if (input !== master) input.closest('.checkbox-container').style.display = 'none';
        }
        const text = master.closest('.checkbox-container').querySelector('label');
        text.textContent = label(k);
        master.dataset.cottonAliasKey = k;
        // Capture runs before the native facet form's change listener.
        master.addEventListener('change', () => {
          for (const input of inputs) input.checked = master.checked;
        }, true);
      }
      const updateCount = () => {
        const values = new Set();
        for (const [name, value] of new FormData(this.querySelector('form'))) {
          if (!value || !name.startsWith('filter.') || name === 'filter.v.availability') continue;
          values.add(name === param ? name + ':' + (key(value) || value) : name.startsWith('filter.v.price.') ? 'price' : name + ':' + value);
        }
        for (const button of this.querySelectorAll('button[is="facet-apply-button"]')) {
          if (button.filterCountElement) button.filterCountElement.innerText = values.size ? ` (${values.size})` : '';
        }
      };
      this.addEventListener('change', () => queueMicrotask(updateCount), true);
      queueMicrotask(updateCount);
    }
  }
  class CottonEbatActive extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const groups = new Map();
      for (const chip of this.querySelectorAll('[data-cotton-ebat-value]')) {
        const k = key(chip.dataset.cottonEbatValue);
        if (k) { if (!groups.has(k)) groups.set(k, []); groups.get(k).push(chip); }
      }
      for (const [k, chips] of groups) {
        const first = chips[0];
        const link = first.querySelector('a');
        for (const node of [...first.childNodes]) if (node.nodeType === Node.TEXT_NODE) node.remove();
        first.prepend(document.createTextNode('Ebat: ' + label(k)));
        for (const chip of chips.slice(1)) chip.style.display = 'none';
        link.setAttribute('aria-label', label(k) + ' ölçüsünü kaldır');
        const url = new URL(link.href);
        const remaining = url.searchParams.getAll(param).filter(value => key(value) !== k);
        url.searchParams.delete(param);
        for (const value of remaining) url.searchParams.append(param, value);
        url.searchParams.delete('page');
        link.href = url.href;
      }
    }
  }
  if (!customElements.get('cotton-ebat-aliases')) customElements.define('cotton-ebat-aliases', CottonEbatAliases);
  if (!customElements.get('cotton-ebat-active')) customElements.define('cotton-ebat-active', CottonEbatActive);
})();
